import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { ModalHeader } from "./Components/modal-header.component";
import { ModalTable } from "./Components/modal-table.component";
import "./index.scss";
import PaginationButtonsBlock from "../../../pagination-block/pagination-buttons-block";

export const DetailModal = ({ show = false, hideModal = () => {}, metric = null }) => {
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <Modal
      show={show}
      onHide={hideModal}
      centered
      dialogClassName="detail-modal-dialog"
      className="detail-modal"
      aria-labelledby="detail-modal"
      scrollable
    >
      <Modal.Header className="modal-header">
        <ModalHeader metric={metric} closeModal={hideModal} />
      </Modal.Header>
      <Modal.Body className="modal-body">
        <ModalTable metric={metric} />
        <div className="mt-4 d-flex justify-content-start">
          <PaginationButtonsBlock
            pageNumber={currentPage}
            maxPageNumber={10}
            onButtonClick={(page) => setCurrentPage(page)}
            onArrowClick={(isNext) => {
              // Left arrow passes false, right arrow passes nothing (undefined)
              if (isNext === false) {
                setCurrentPage(prev => Math.max(prev - 1, 1));
              } else {
                setCurrentPage(prev => Math.min(prev + 1, 10));
              }
            }}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

